import http from '@/utils/http.js'
/*
 * @DESC:api接口
 */
const GET_VIP_CARD_INFO = "/api/getVipCardInfo";//获取会员卡详情
const SAVE_VIP_CARD = "/api/saveVipCard";//保存会员卡

export default {
	getVipCardInfo: async({
		commit,
		dispatch,
		state,
		getters
	}, params={}) => {
		try{
			const data = await http.get(GET_VIP_CARD_INFO, params);
			commit('GET_VIP_CARD_INFO', data);
		} catch(e) {
			throw e
		}
	},
	
	saveVipCard: async({
		commit,
		dispatch,
		state,
		getters
	}, params={}) => {
		try{
			await http.post(SAVE_VIP_CARD, params);
		} catch(e) {
			throw e
		}
	}
}


// WEBPACK FOOTER //
// ./src/store/mp/vip_card/actions.js